function formatPhoneNumber(value: string) {
  if (!value) return value
  // Remove all non-digits
  const phoneNumber = value.replace(/\D/g, '')
  // Don't format if less than 4 digits
  if (phoneNumber.length < 4) return phoneNumber
  // Format as (XXX) if between 3 and 6 digits
  if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`
  }
  // Format as (XXX) XXX-XXXX if 7 or more digits
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`
}

export default formatPhoneNumber
